import React from "react";
import InvoiceTable from "./InvoiceTable";
import QRCodeSection from "./QRCodeSection";
import "./CombinedContainer.css";

function CombinedContainer({ invoiceData, qrString }) {
  return (
    <div className="combined-container">
      <div className="invoice-table-left">
        <InvoiceTable invoiceData={invoiceData} />
      </div>
      <div className="qr-code-right">
        <QRCodeSection qrString={qrString} />
      </div>
    </div>
  );
}

export default CombinedContainer;
